/* Pack Builder v6 - con limite qty por pack + lista curada */
(function(){
"use strict";

var CM={"negro":"#1a1a1a","beige":"#d4b896","chocolate":"#5c3a1e","café":"#6b4226","café claro":"#a67c52","blanco":"#fff","gris":"#888","azul":"#1565c0","cherry":"#8b0000","rosa":"#e8a0bf","piel":"#deb887","verde":"#2e7d32","gris oscuro":"#555"};

/* Defaults — si el producto tiene metafields configurados desde admin, los metafields ganan.
   Para customizar productos por pack desde admin sin tocar código:
   - Settings → Custom data → Products → Add definition:
     namespace: custom, key: pack_products  (Type: Single line text)
     namespace: custom, key: pack_qty       (Type: Integer)
   - Luego en cada producto pack, ingresar los handles separados por coma. Ej:
     pack_products = "body-figura-ideal,body-silueta-perfecta,falda-crystal"
     pack_qty = 3
*/
var PB={
  "pack-arma-t-body":{
    t:"ARMA TU PACK",
    s:"Elige tus productos",
    products:["body-figura-ideal","body-silueta-perfecta","body-curvy-ml","body-full-figura","body-figura-ideal-negro","body-fit-mc","body-diosa-fit-copia","body-fajero-princesa"]
  },
  "pack-silueta-de-impacto":{
    t:"PACK SILUETA IMPECABLE",
    s:"Elige 3 productos",
    qty:3,
    products:["body-figura-ideal"]
  },
  "pack-silueta-impecable-24-7":{
    t:"PACK SILUETA DE IMPACTO",
    s:"Elige 3 productos",
    qty:3,
    products:["body-figura-ideal"]
  },
  "pack-confianza-impecable":{
    t:"PACK CONFIANZA IMPECABLE",
    s:"Elige 3 productos",
    qty:3,
    products:["body-figura-ideal"]
  },
  "pack-silueta-pulida":{
    t:"PACK SILUETA PULIDA",
    s:"Elige 3 productos",
    qty:3,
    products:["body-figura-ideal"]
  },
  "pack-invisible-shape":{
    t:"PACK INVISIBLE SHAPE",
    s:"Elige 3 productos",
    qty:3,
    products:["body-figura-ideal"]
  }
};

var D={};
var cfg=null;
var pState={};
var cart=[];
/* Stock real inyectado server-side desde Liquid (variant.inventory_quantity) */
var STOCK={};
function loadStockData(){
  var el=document.getElementById("scpb-stock");
  if(!el)return;
  try{STOCK=JSON.parse(el.textContent)}catch(e){STOCK={}}
}
function getVariantStock(handle,vid){
  if(STOCK[handle]&&STOCK[handle][vid]!==undefined)return STOCK[handle][vid];
  return null; /* unknown */
}
/* Tracking de stock limitado por variante (persiste en sessionStorage) */
function getLimitedMap(){
  try{return JSON.parse(sessionStorage.getItem('scpb_limited')||'{}')}catch(e){return{}}
}
function setLimitedMax(vid,maxQty){
  try{var m=getLimitedMap();m[vid]=maxQty;sessionStorage.setItem('scpb_limited',JSON.stringify(m))}catch(e){}
}
function getLimitedMax(vid){var m=getLimitedMap();return m[vid]!==undefined?m[vid]:null}

function gImg(p,color){
  var fallback=p.featured_image||(p.images&&p.images[0])||"";
  if(!color)return fallback;
  for(var i=0;i<p.variants.length;i++){
    var v=p.variants[i];
    if((v.option1||"").toLowerCase()===color.toLowerCase()&&v.featured_image&&v.featured_image.src)return v.featured_image.src;
  }
  return fallback;
}

function findVariant(handle,color,size){
  var p=D[handle];if(!p)return null;
  for(var i=0;i<p.variants.length;i++){
    var v=p.variants[i];
    var opts=[v.option1||"",v.option2||"",v.option3||""];
    var hasColor=opts.some(function(o){return o.toLowerCase()===color.toLowerCase();});
    var hasSize=opts.some(function(o){return o===size;});
    if(hasColor&&hasSize&&v.available!==false)return v;
  }
  return null;
}

function colorHasStock(p,color){
  var handle=p.handle;
  for(var i=0;i<p.variants.length;i++){
    var v=p.variants[i];
    var opts=[v.option1||"",v.option2||"",v.option3||""];
    if(opts.some(function(o){return o.toLowerCase()===color.toLowerCase();})){
      if(v.available===false)continue;
      /* Si tenemos stock real, contar también lo ya seleccionado en pack */
      var realStock=getVariantStock(handle,v.id);
      if(realStock===null)return true; /* stock desconocido, asumir disponible */
      var inCart=0;
      cart.forEach(function(c){if(c.vid===v.id)inCart=c.qty});
      if(realStock-inCart>0)return true;
    }
  }
  return false;
}

function sizeAvailable(p,color,size){
  var handle=p.handle;
  for(var i=0;i<p.variants.length;i++){
    var v=p.variants[i];
    var opts=[v.option1||"",v.option2||"",v.option3||""];
    var hasC=!color||opts.some(function(o){return o.toLowerCase()===color.toLowerCase();});
    var hasS=opts.some(function(o){return o===size;});
    if(hasC&&hasS){
      if(v.available===false)continue;
      var realStock=getVariantStock(handle,v.id);
      if(realStock===null)return true; /* stock desconocido, asumir disponible */
      var inCart=0;
      cart.forEach(function(c){if(c.vid===v.id)inCart=c.qty});
      if(realStock-inCart>0)return true;
    }
  }
  return false;
}

function totalQty(){
  var t=0;cart.forEach(function(c){t+=c.qty;});return t;
}

function findCartItem(handle,color,size){
  for(var i=0;i<cart.length;i++){
    if(cart[i].handle===handle&&cart[i].color.toLowerCase()===color.toLowerCase()&&cart[i].size===size)return i;
  }
  return -1;
}

function addToCart(idx){
  var handle=cfg.products[idx];
  var st=pState[idx];
  if(!st.cl||!st.sz)return;
  var v=findVariant(handle,st.cl,st.sz);
  if(!v)return;
  /* Respetar limite de cantidad si el pack lo define */
  if(cfg.qty&&totalQty()>=cfg.qty)return;
  var ci=findCartItem(handle,st.cl,st.sz);
  var currentQty=ci>-1?cart[ci].qty:0;
  var realStock=getVariantStock(handle,v.id);
  if(realStock!==null){
    /* Stock real del server tiene prioridad — ignora aprendizaje de sesión */
    if(currentQty>=realStock)return;
  }else{
    /* Solo si NO hay stock real (variante desconocida), usa aprendizaje sesión */
    var limMax=getLimitedMax(v.id);
    if(limMax!==null&&currentQty>=limMax)return;
  }
  var p=D[handle];
  if(ci>-1){cart[ci].qty++;}
  else{cart.push({handle:handle,name:p.title,color:st.cl,size:st.sz,vid:v.id,qty:1});}
  render();
}

function removeFromCart(ci){
  if(ci<0||ci>=cart.length)return;
  cart[ci].qty--;
  if(cart[ci].qty<=0)cart.splice(ci,1);
  render();
}

function render(){
  var c=document.getElementById("scpb-products");if(!c)return;
  var total=totalQty();
  var parts=[];

  cfg.products.forEach(function(handle,idx){
    var p=D[handle];
    if(!p){
      /* Producto no se cargó (404 o fetch falló): mostrar placeholder bloqueado */
      parts.push('<div class="scpb__row scpb__row--unavailable">');
      parts.push('<div class="scpb__row-img" style="background:#f0f0f0;display:flex;align-items:center;justify-content:center;color:#999;font-size:18px;">!</div>');
      parts.push('<div class="scpb__row-body">');
      parts.push('<div class="scpb__row-head"><span class="scpb__row-name" style="color:#999;text-decoration:line-through;">'+handle+'</span></div>');
      parts.push('<div class="scpb__row-controls"><div class="scpb__row-opts"><span style="font-size:11px;color:#999;font-weight:600;">Producto no disponible</span></div>');
      parts.push('<button type="button" class="scpb__add off" disabled>+</button>');
      parts.push('</div></div></div>');
      return;
    }
    var st=pState[idx];
    var cOpt=null;var tOpt=null;
    p.options.forEach(function(o){var n=o.name.toLowerCase();
      if(n.indexOf("color")>-1)cOpt=o;
      if(n.indexOf("talla")>-1||n==="size")tOpt=o;});

    var img=gImg(p,st.cl);
    var price=p.variants[0].price/100;
    var maxReached=cfg.qty&&total>=cfg.qty;
    var selVariant=st.cl&&st.sz?findVariant(handle,st.cl,st.sz):null;
    /* Stock real del server tiene prioridad sobre aprendizaje sesión */
    var atStockLimit=false;
    if(selVariant){
      var ci=findCartItem(handle,st.cl,st.sz);
      var cqty=ci>-1?cart[ci].qty:0;
      var realStock=getVariantStock(handle,selVariant.id);
      if(realStock!==null){
        if(cqty>=realStock)atStockLimit=true;
      }else{
        var lim=getLimitedMax(selVariant.id);
        if(lim!==null&&cqty>=lim)atStockLimit=true;
      }
    }
    var canAdd=!!selVariant&&!maxReached&&!atStockLimit;

    /* Calcular cantidad total de este producto en el cart (suma todas las variantes) */
    var prodQtyInCart=0;
    cart.forEach(function(c){ if(c.handle===handle) prodQtyInCart+=c.qty; });
    var rowSelected=prodQtyInCart>0;

    parts.push('<div class="scpb__row'+(rowSelected?' is-selected':'')+'">');
    parts.push('<img class="scpb__row-img" src="'+img+'" alt="'+p.title+'">');
    parts.push('<div class="scpb__row-body">');

    parts.push('<div class="scpb__row-head">');
    parts.push('<span class="scpb__row-name">'+p.title+(rowSelected?'<span class="scpb__row-qty-badge">×'+prodQtyInCart+'</span>':'')+'</span>');
    parts.push('<span class="scpb__row-price">$'+Math.round(price).toLocaleString("es-CL")+'</span>');
    parts.push('</div>');

    parts.push('<div class="scpb__row-controls">');
    parts.push('<div class="scpb__row-opts">');

    if(cOpt&&cOpt.values.length>0){
      parts.push('<div class="scpb__colors">');
      cOpt.values.forEach(function(cv,ci){
        var bg=CM[cv.toLowerCase()]||"#ccc";
        var on=st.cl&&st.cl.toLowerCase()===cv.toLowerCase()?" active":"";
        var out=colorHasStock(p,cv)?"":" out";
        var border=cv.toLowerCase()==="blanco"?"border:2px solid #ddd":"";
        var ttl=out?cv+" - Sin stock":cv;
        parts.push('<div class="scpb__clr'+on+out+'" style="background:'+bg+';'+border+'" data-i="'+idx+'" data-c="'+ci+'" title="'+ttl+'"></div>');
      });
      parts.push('</div>');
    }

    if(tOpt){
      parts.push('<div class="scpb__sizes">');
      tOpt.values.forEach(function(tv,ti){
        var on=st.sz===tv?" active":"";
        var out=sizeAvailable(p,st.cl,tv)?"":" out";
        parts.push('<button type="button" class="scpb__sz'+on+out+'" data-i="'+idx+'" data-t="'+ti+'" title="'+(out?tv+" - Sin stock":tv)+'">'+tv+'</button>');
      });
      parts.push('</div>');
    }

    parts.push('</div>');
    /* Decidir label + estado del botón según contexto.
       NO mostrar "AGOTADO" cuando solo falta que el cliente elija talla/color. */
    var btnLabel, btnTitle, btnDisabled;
    if(prodQtyInCart>0){
      /* Stepper — ya tiene unidades */
      var canPlus = canAdd;
      parts.push('<div class="scpb__stepper">');
      parts.push('<button type="button" class="scpb__step-btn" data-step="-" data-i="'+idx+'" aria-label="Quitar">−</button>');
      parts.push('<span class="scpb__step-qty">'+prodQtyInCart+'</span>');
      parts.push('<button type="button" class="scpb__step-btn'+(canPlus?'':' is-disabled')+'" data-step="+" data-i="'+idx+'" aria-label="Agregar"'+(canPlus?'':' disabled')+' title="'+(atStockLimit?'Stock limitado':(maxReached?'Pack lleno':'Agregar'))+'">+</button>');
      parts.push('</div>');
    } else {
      if(maxReached){
        btnLabel='LLENO'; btnTitle='Pack lleno'; btnDisabled=true;
      } else if(atStockLimit){
        btnLabel='AGOTADO'; btnTitle='Sin stock'; btnDisabled=true;
      } else if(!selVariant){
        /* Aún no eligió talla/color → AGREGAR desactivado, NO AGOTADO */
        btnLabel='AGREGAR'; btnTitle='Elige color y talla'; btnDisabled=true;
      } else {
        btnLabel='AGREGAR'; btnTitle='Agregar al pack'; btnDisabled=false;
      }
      /* Texto visible en web + icono "+" visible en móvil (controlado por CSS) */
      parts.push('<button type="button" class="scpb__add'+(btnDisabled?' off':'')+'" data-i="'+idx+'" title="'+btnTitle+'" aria-label="'+btnTitle+'">');
      parts.push('<span class="scpb__add-text">'+btnLabel+'</span>');
      parts.push('<span class="scpb__add-icon" aria-hidden="true">+</span>');
      parts.push('</button>');
    }
    parts.push('</div>');
    parts.push('</div>');
    parts.push('</div>');
  });

  /* Batch all DOM writes together to trigger a single layout/paint */
  var summaryEl=document.getElementById("scpb-summary");
  var countEl=document.getElementById("scpb-count");
  var btnEl=document.getElementById("scpb-cart");

  /* Build summary HTML */
  var shtml;
  var showSummary;
  if(cart.length>0){
    var sParts=[];
    cart.forEach(function(item,ci){
      sParts.push('<div class="scpb__cart-item">');
      sParts.push('<span>'+item.qty+'x '+item.name+' — '+item.color+' — '+item.size+'</span>');
      sParts.push('<button type="button" class="scpb__cart-rm" data-ci="'+ci+'" title="Quitar">×</button>');
      sParts.push('</div>');
    });
    shtml=sParts.join('');
    showSummary=true;
  }else{
    shtml='';
    showSummary=false;
  }

  /* Single batched DOM write */
  c.innerHTML=parts.join('');
  summaryEl.innerHTML=shtml;
  summaryEl.style.display=showSummary?'block':'none';
  /* Mostrar contador "X de N" si el pack tiene qty fijo, sino solo X */
  if(cfg.qty){countEl.textContent=total+' de '+cfg.qty;}
  else{countEl.textContent=total;}

  /* Habilitar botón solo cuando alcance qty (si está definido) */
  if(cfg.qty){
    if(total>=cfg.qty){
      btnEl.disabled=false;
      btnEl.textContent="AGREGAR PACK AL CARRITO";
      btnEl.className="scpb__cart ready";
    }else{
      btnEl.disabled=true;
      var falta=cfg.qty-total;
      btnEl.textContent="FALTA ELEGIR "+falta+" PRODUCTO"+(falta>1?"S":"");
      btnEl.className="scpb__cart";
    }
  }else{
    if(total>0){
      btnEl.disabled=false;
      btnEl.textContent="AGREGAR PACK AL CARRITO";
      btnEl.className="scpb__cart ready";
    }else{
      btnEl.disabled=true;
      btnEl.textContent="Agrega productos a tu pack";
      btnEl.className="scpb__cart";
    }
  }
}

function bindEvents(){
  var prodEl=document.getElementById("scpb-products");
  var summaryEl=document.getElementById("scpb-summary");
  var cartBtn=document.getElementById("scpb-cart");

  prodEl.addEventListener("click",function(e){
    var clr=e.target.closest(".scpb__clr");
    if(clr){
      if(clr.classList.contains("out"))return;
      var idx=parseInt(clr.getAttribute("data-i"));
      var ci=parseInt(clr.getAttribute("data-c"));
      var p=D[cfg.products[idx]];
      var cOpt=null;
      p.options.forEach(function(o){if(o.name.toLowerCase().indexOf("color")>-1)cOpt=o;});
      if(cOpt) pState[idx].cl=cOpt.values[ci];
      /* If currently selected size is unavailable for new color, deselect it */
      if(pState[idx].sz&&!sizeAvailable(p,pState[idx].cl,pState[idx].sz))pState[idx].sz=null;
      render();return;
    }

    var szBtn=e.target.closest(".scpb__sz");
    if(szBtn){
      if(szBtn.classList.contains("out"))return;
      var idx2=parseInt(szBtn.getAttribute("data-i"));
      var ti=parseInt(szBtn.getAttribute("data-t"));
      var p2=D[cfg.products[idx2]];
      var tOpt=null;
      p2.options.forEach(function(o){var n=o.name.toLowerCase();if(n.indexOf("talla")>-1||n==="size")tOpt=o;});
      if(tOpt) pState[idx2].sz=tOpt.values[ti];
      render();return;
    }

    var addBtn=e.target.closest(".scpb__add");
    if(addBtn&&!addBtn.classList.contains("off")){
      var idx3=parseInt(addBtn.getAttribute("data-i"));
      addToCart(idx3);
      return;
    }

    /* Stepper +/- */
    var stepBtn=e.target.closest(".scpb__step-btn");
    if(stepBtn&&!stepBtn.disabled){
      var idx4=parseInt(stepBtn.getAttribute("data-i"));
      var step=stepBtn.getAttribute("data-step");
      if(step==="+"){
        addToCart(idx4);
      } else if(step==="-"){
        /* Quitar la última variante agregada de este producto */
        var handle4=cfg.products[idx4];
        for(var i=cart.length-1;i>=0;i--){
          if(cart[i].handle===handle4){
            cart[i].qty--;
            if(cart[i].qty<=0)cart.splice(i,1);
            render();
            break;
          }
        }
      }
      return;
    }
  });

  summaryEl.addEventListener("click",function(e){
    var rm=e.target.closest(".scpb__cart-rm");
    if(rm){
      var ci=parseInt(rm.getAttribute("data-ci"));
      removeFromCart(ci);
    }
  });

  cartBtn.addEventListener("click",function(){
    if(totalQty()<1)return;
    var items=cart.map(function(c){return{id:c.vid,quantity:c.qty}});
    if(!items.length)return;
    cartBtn.textContent="AGREGANDO...";cartBtn.disabled=true;

    var requestedTotal=items.reduce(function(s,it){return s+it.quantity},0);

    fetch("/cart.js",{credentials:"same-origin"})
      .then(function(r){return r.json()})
      .then(function(cartBefore){
        var beforeMap={};
        (cartBefore.items||[]).forEach(function(it){beforeMap[it.variant_id||it.id]=it.quantity});

        return fetch("/cart/add.js",{method:"POST",headers:{"Content-Type":"application/json","Accept":"application/json"},credentials:"same-origin",body:JSON.stringify({items:items})})
          .then(function(r){return r.json().then(function(j){return{ok:r.ok&&!j.status,data:j}})})
          .then(function(res){
            if(res.ok){
              cartBtn.textContent="PACK AGREGADO!";cartBtn.className="scpb__cart added";
              setTimeout(function(){if(window.scOpenCartDrawer){scOpenCartDrawer()}else{window.location.href="/cart"}},800);
              return;
            }
            /* Shopify devolvió 422 — verificar qué SÍ se agregó en el cart real */
            return fetch("/cart.js",{credentials:"same-origin"}).then(function(r){return r.json()}).then(function(cartAfter){
              var afterMap={};
              (cartAfter.items||[]).forEach(function(it){afterMap[it.variant_id||it.id]=it.quantity});

              var addedTotal=0;
              items.forEach(function(it){
                addedTotal+=((afterMap[it.id]||0)-(beforeMap[it.id]||0));
              });

              if(addedTotal>=requestedTotal){
                /* Cart sí recibió todo lo solicitado — éxito a pesar del 422 */
                cartBtn.textContent="PACK AGREGADO!";cartBtn.className="scpb__cart added";
                setTimeout(function(){if(window.scOpenCartDrawer){scOpenCartDrawer()}else{window.location.href="/cart"}},800);
                return;
              }

              if(addedTotal>0){
                /* Parcial: algunos sí se agregaron — redirigir al carrito y dejar que el usuario vea */
                cartBtn.textContent="PACK AGREGADO ("+addedTotal+"/"+requestedTotal+")";cartBtn.className="scpb__cart added";
                setTimeout(function(){if(window.scOpenCartDrawer){scOpenCartDrawer()}else{window.location.href="/cart"}},1000);
                return;
              }

              /* Nada se agregó — error real, mostrar mensaje */
              var problemItem=null;
              items.forEach(function(it){
                var got=(afterMap[it.id]||0)-(beforeMap[it.id]||0);
                if(got<it.quantity){
                  if(!problemItem)problemItem=cart.find(function(c){return c.vid===it.id});
                  var max=(beforeMap[it.id]||0)+got;
                  setLimitedMax(it.id,Math.max(max,0));
                }
              });
              refreshStockAndRerender(function(){
                render();
                var msg=problemItem
                  ? ("Sin stock: "+problemItem.name+" "+problemItem.color+" "+problemItem.size)
                  : "Sin stock en una variante";
                cartBtn.textContent=msg.length>55?"Sin stock — cambia la selección":msg+" — cambia la selección";
                cartBtn.disabled=false;
                cartBtn.className="scpb__cart";
              });
            });
          });
      })
      .catch(function(err){
        cartBtn.textContent="ERROR DE CONEXIÓN";
        cartBtn.disabled=false;
        console.error("[pack-builder] error:",err);
      });
  });

  /* Re-fetch product data para todos los productos del pack, luego callback */
  function refreshStockAndRerender(cb){
    var fetches=cfg.products.map(function(h){
      return fetch("/products/"+h+".js?_t="+Date.now())
        .then(function(r){return r.json()})
        .then(function(data){D[h]=data;})
        .catch(function(){});
    });
    Promise.all(fetches).then(function(){if(cb)cb();});
  }
}

function loadProducts(){
  loadStockData();
  var fetches=cfg.products.map(function(h){
    return fetch("/products/"+h+".js")
      .then(function(r){return r.json()})
      .then(function(data){D[h]=data;})
      .catch(function(){/* product fetch failed, skip */});
  });
  Promise.all(fetches).then(function(){render();bindEvents();});
}

function setup(){
  var el=document.getElementById("scpb");if(!el)return;
  var handle=el.getAttribute("data-pack-handle");

  var inlineCfg=null;
  var cfgEl=document.getElementById("scpb-config");
  if(cfgEl){try{inlineCfg=JSON.parse(cfgEl.textContent);}catch(e){}}
  var pbCfg=(handle&&PB[handle])?PB[handle]:null;

  /* Merge: admin (inline metafield) gana en productos/título/sub,
     pero el qty del default de código se mantiene si no está en admin. */
  if(inlineCfg&&inlineCfg.products&&inlineCfg.products.length){
    cfg={
      products:inlineCfg.products,
      qty:(inlineCfg.qty!=null&&inlineCfg.qty!==0)?inlineCfg.qty:(pbCfg?pbCfg.qty:null),
      t:inlineCfg.t||(pbCfg?pbCfg.t:'PACK'),
      s:inlineCfg.s||(pbCfg?pbCfg.s:'Elige tus productos')
    };
  }else if(pbCfg){
    cfg=pbCfg;
  }

  if(!cfg||!cfg.products||!cfg.products.length){
    el.style.display="none";return;
  }

  el.querySelector(".scpb__title").textContent=cfg.t;
  el.querySelector(".scpb__sub").textContent=cfg.s;

  cfg.products.forEach(function(_,idx){pState[idx]={cl:null,sz:null}});
  loadProducts();
}

if(document.readyState==="loading"){
  document.addEventListener("DOMContentLoaded",setup);
}else{
  if(typeof requestIdleCallback==="function"){
    requestIdleCallback(setup);
  }else{
    setup();
  }
}
})();
